import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

@Component({
  selector: 'app-status-cliente',
  templateUrl: './status-cliente.component.html',
  styleUrls: ['./status-cliente.component.scss']
})
export class StatusClienteComponent implements OnInit {
  statusList: { nome: string }[] = [];
  statusSelecionado: any = null;
  cadastroForm: FormGroup;
  modalRef!: NgbModalRef;

  @ViewChild('formModal') formModal!: TemplateRef<any>;

  constructor(
    private fb: FormBuilder, 
    private modalService: NgbModal,
    private ajaxService: AjaxService,
    private util: UtilService
  ) {
    this.cadastroForm = this.fb.group({
      nome: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.carregarStatus();
  }

  carregarStatus(): void {
    this.util.showLoading();
    let url = API + "Status/Status";
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.statusList = response.data;
        this.util.closeLoading();
      },
      error: (error) => {
        console.error('Erro ao carregar status:', error);
        this.util.closeLoading();
      }
    });
  }

  openModal(modal: TemplateRef<any>, isNew: boolean = false): void {
    if (isNew) {
      this.statusSelecionado = null;
      this.cadastroForm.reset();
    }
    this.modalRef = this.modalService.open(modal, { size: 'lg' });
  }

  editarStatus(status: any): void {
    this.statusSelecionado = status;
    this.cadastroForm.patchValue(status);
  }

  onSubmit(): void {
    if (this.cadastroForm.valid) {
      const formValue = this.cadastroForm.value;
      let dados = {
        "NOME": formValue.nome
      };

      // Se for edição, incluir o ID
      if (this.statusSelecionado) {
        dados["ID_STATUS"] = this.statusSelecionado.iD_STATUS;
      }

      let url = API + "Status/Status";
      
      this.util.showLoading();
      this.ajaxService.post(url, dados).subscribe({
        next: (response) => {
          this.util.closeLoading();
          // Recarregar a lista após salvar
          this.carregarStatus();
          this.modalRef.close();
          this.cadastroForm.reset();
        },
        error: (error) => {
          this.util.closeLoading();
          console.error('Erro ao salvar status:', error);
        }
      });
    }
  }
} 